import Radium from "radium";
import React from "react";

import { remoStyles } from "@common/styles";
import { IDevice } from "@common/models";

export interface IEditDeviceProps {
  closeModal: () => void;
  device: IDevice;
  removeDevice: () => void;
}

class EditDevice extends React.Component<IEditDeviceProps, any> {
  public render() {
    const remoCancelButtonStyle = {
      ...remoStyles.okButton,
      backgroundColor: "#444"
    };

    const { device, removeDevice, closeModal } = this.props;

    return (
      <div style={remoStyles.container as any}>
        <div style={remoStyles.header as any}>Slett enhet</div>
        <div style={remoStyles.text as any}>
          Er du sikker på at du vil fjerne enheten{" "}
          {device ? device.userAgent || device.deviceId : undefined} fra din
          bruker?
        </div>
        <div style={remoStyles.okButton as any} onClick={removeDevice}>
          Slett enhet
        </div>
        <div style={remoCancelButtonStyle as any} onClick={closeModal}>
          Avbryt
        </div>
      </div>
    );
  }
}

export default Radium(EditDevice);
